import { AdminHeader } from 'components/admin/header/AdminHeader';
import { GuideIntegrationInfo } from 'components/admin/integration/GuideIntegrationInfo';
import { GuideIntegrationPoints } from 'components/admin/integration/GuideIntegrationPoints';
import { LanguageSwitch } from 'components/guide/other/LanguageSwitch';
import { Page } from 'elements/admin/layout/Page';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { GlobalContext } from 'session/state/context';
import styled from 'styled-components/macro';

export const GuideIntegrationPage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.from) {
            window.scrollTo(0, location.state.from.scrollY);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    if (!state.loggedUserChecked) {
        return null;
    }

    return (
        <S_GuideIntegrationPage>
            <AdminHeader />
            <GuideIntegrationInfo />
            <GuideIntegrationPoints />
            <S_LanguageSwitch />
        </S_GuideIntegrationPage>
    );
};

const S_GuideIntegrationPage = styled(Page)``;

const S_LanguageSwitch = styled(LanguageSwitch)`
    margin: 0 0 50px 0;
`;
